export default __webpack_public_path__ + "8e2ef3e168ca3fc507f920c49672ff8c.svg";